import type {Listing} from "@hosttools/core/generated/models";
import {useMemo} from "react";

import useListing from "../useListing";

export function useChannelData<T extends keyof Listing["channels"]>(
    listingID: string | undefined,
    channel: T
) {
    const listing = useListing(listingID);

    return useMemo(() => {
        return listing?.channels[channel];
    }, [listing, channel]);
}
